import { render, staticRenderFns } from "./ChangeRoleForm.vue?vue&type=template&id=753761e0&"
import script from "./ChangeRoleForm.vue?vue&type=script&lang=ts&"
export * from "./ChangeRoleForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeRoleForm.vue?vue&type=style&index=0&id=753761e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports